import React, { useContext } from "react";
import { Link } from "react-router-dom";
import banner from "../../assets/banner.png";
import { AuthContext } from "../../context/AuthProvider";

const Header = () => {
  const { user, logOut } = useContext(AuthContext);

  const handleLogOut = () => {
    logOut();
  };

  const menuItems = (
    <React.Fragment>
      <li className="font-semibold">
        <Link to="/">Home</Link>
      </li>
      <li className="font-semibold">
        <Link to="/allproducts">Products</Link>
      </li>
      <li className="font-semibold">
        <Link to="/blogs">Blogs</Link>
      </li>
      {user?.email ? (
        <>
          <li className="font-semibold">
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <button
            onClick={handleLogOut}
            className="btn btn-outline btn-error text-white font-semibold"
          >
            Logout
          </button>
        </>
      ) : (
        <>
          <li className="font-semibold">
            <Link to="/login">Login</Link>
          </li>
          <li className="font-semibold">
            <Link to="/register">Register</Link>
          </li>
        </>
      )}
    </React.Fragment>
  );

  return (
    <div className="navbar bg-base-100 flex justify-between">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={1}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            {menuItems}
          </ul>
        </div>
        <Link to="/" className="btn btn-ghost normal-case font-bold text-xl">
          <img src={banner} className="w-16" alt="" />
          Motohub
        </Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal p-0">{menuItems}</ul>
      </div>
    </div>
  );
};

export default Header;
